


































// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

// Models
import Bill, { TransactionType, TransactionTypeLiterals } from '@/manager/billing/models/bill.model';
import Provider from '@/manager/business/models/provider.model';

// Components
import Input, { InputSize } from '@/shared/components/input.component.vue';

// Mixins
import ErrorMixin from '@/shared/mixins/error.mixin.ts';


@Component({
    components: {
        Input,
    },
    computed: {
        ...mapGetters({
            bill: 'getCurrentBill',
        }),
    },
})
export default class ProviderPartial extends Mixins<ErrorMixin> (ErrorMixin) {
    @Prop({ default: new Provider() }) private provider!: any;

    private inputSize = InputSize;
    private bill!: Bill;
}
